import React from 'react'
import { Col, Container, Form, Modal as BootstrapModal, Row } from 'react-bootstrap'
import { Modal } from '../../../components/Modal/Modal'
import { Controller, useForm } from 'react-hook-form'
import { TemplateUpdateRequest, TemplateValue } from '../../../models/TemplateLibrary'

export interface TemplateEditModalProps {
  show: boolean
  loading: boolean
  templateValue: TemplateValue
  onSave: (request: TemplateUpdateRequest) => void
  onCancel: () => void
}

export const TemplateEditModal: React.FC<TemplateEditModalProps> = ({ show, loading, templateValue, onSave, onCancel }) => {
  const { control, getValues } = useForm<TemplateUpdateRequest>({
    defaultValues: {
      name: templateValue.name,
      description: templateValue.description,
    } as TemplateUpdateRequest,
  })

  const body = (
    <Container>
      <Row className='m-0'>
        <Col className='p-0'>
          <Controller
            name='name'
            control={control}
            render={({ field }) => (
              <div>
                <Form.Label htmlFor={field.name}>Name</Form.Label>
                <Form.Control id={field.name} placeholder='Enter a name...' {...field} />
              </div>
            )}
          />
        </Col>
      </Row>
      <Row className='m-0 pt-4'>
        <Col className='p-0'>
          <Controller
            name='description'
            control={control}
            render={({ field }) => (
              <div>
                <Form.Label htmlFor={field.name}>Description</Form.Label>
                <Form.Control id={field.name} as='textarea' rows={3} placeholder='Enter a description...' {...field} />
              </div>
            )}
          />
        </Col>
      </Row>
    </Container>
  )

  return (
    <Modal
      header={<BootstrapModal.Title>Edit template details</BootstrapModal.Title>}
      body={body}
      show={show}
      onHide={onCancel}
      footerPrimaryActionTitle='Save'
      footerPrimaryActionLoading={loading}
      showFooterActions={true}
      centered
      onFooterPrimaryAction={() => onSave(getValues())}
      onFooterSecondaryAction={onCancel}
      headerBodySeparator={true}
    />
  )
}
